import ENV from './Env.js';




export const getTagList = () => {
  return fetch(ENV.API_URL + '/tags/all', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((response) => {
    return response.json()
  });
}


export const makeTag = (_api, _data) => {
  _data['api_token'] = _api; 
  return fetch(ENV.API_URL + '/tags/store', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(_data)
  }).then(function (response) {
    return response.json();
  });
}


export const updateTag = (_api, _data) => {
  _data['api_token'] = _api;

  return fetch(`${ENV.API_URL}/tags/update/${_data['id']}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(_data)
  }).then(function (response) {
    return response.json();
  });
}

